import Primrose1 from "../../../media/apartment/primerose/3br/primrose1.jpg";
import Primrose2 from "../../../media/apartment/primerose/3br/primrose2.png";
import Primrose3 from "../../../media/apartment/primerose/3br/primrose3.jpg";

const apartprimrose3brimages = [Primrose1, Primrose2, Primrose3];

export default apartprimrose3brimages;
